import PipelineEditPageContainer from './containers/PipelineEditPageContainer'

export default PipelineEditPageContainer
